import { useMemo } from 'react';
import { useRecordContext } from 'react-admin';
import { ConflictFields } from '../../constants/conflictFields';
import { EntityTypes } from '../../constants/entityTypes';

export type DatapointContext = {
  name: ConflictFields;
  entityId: string;
  entityType: EntityTypes;
  identificationInfo?: unknown;
}

const useConflictContext = () => {
  const record = useRecordContext<DatapointContext>();
  const {
    name,
    entityId,
    entityType,
    identificationInfo,
  } = record ?? {};

  const searchParams = useMemo(() => {
    const search = new URLSearchParams();
    if (name) search.append('name', name);
    if (identificationInfo) search.append('identificationInfo', JSON.stringify(identificationInfo));
    return search;
  }, [identificationInfo, name]);

  if (
    !record
    || !name
    || !entityId
    || !entityType
  ) throw new Error('Conflict context hook has been used outside of a RecordContext component');

  return {
    name,
    entityId,
    entityType,
    identificationInfo,
    searchParams,
  };
};

export default useConflictContext;
